<script>
  import { mapGetters } from "vuex";
  import EdaIcon from './components/vIcon'
  import EdaLink from './components/vLink'
  import PORTAL from './config/portals/config.js'
  import GlobalNotice from "./components/vNotice";
  import VModalAddTelephone from "./components/vModalAddTelephone";

  export default {
    name: "eda-layout",
    components: {
      VModalAddTelephone,
      GlobalNotice,
      EdaIcon,
      EdaLink,
    },
    props: {
      logoAssets: {
        type: Object, default: function () {
          return {
            "localhos": "jaguar.png",
            "bilia": "bilia.png",
            "bmw": "bmw.png",
            "bos": "bos.png",
            "eda": "eda.png",
            "fjordkraft": "fjordkraft.png",
            "hyundai": "hyundai.png",
            "jaguar": "jaguar.png",
            "moller": "moller.png",
            "nissan": "nissan.png",
            "opel": "opel.png",
            "porsche": "porsche.png",
            "volvo": "volvo.png",
            "sulland": "sulland.png",
            "defa": "defa.png",
            "mobile": "mobile.png",
            "motorpart": "motorpart.png",
            "ford": "ford.png",
            "toyota": "toyota.png",
            "ham": "ham.png",
          }

        }
      }
    },


    methods: {

      splitHostname() {
        var result = {};
        var regexParse = new RegExp('([a-z\-0-9]{2,63})\.([a-z\.]{2,5})$');
        var urlParts = regexParse.exec(window.location.hostname);
        result.domain = urlParts[1];
        result.type = urlParts[2];
        result.subdomain = window.location.hostname.replace(result.domain + '.' + result.type, '').slice(0, -1);
        return result;
      },

      mqc(element) {
        return "eda__" + element + "\@" + $mq;
      }
    },

    computed: {

      ...mapGetters([
        'getUser'
      ]),

      logoUrl() {
        return PORTAL.logoUrl;
      },

      domainHandle() {
        let hostname = this.splitHostname();
        return (hostname.subdomain != 'undefined') ? hostname.subdomain : "eda";
      },

      showEdaLogo() {
        return PORTAL.showEdaLogo;
      },

      minimizeLogo() {
        return !["/"].includes(this.$route.path);
      },

      showUser() {
        return !this.$route.meta.hideUser
      },
      showBack() {
        return !this.$route.meta.hideBack
      },
      showNewOrder() {
        return this.$route.meta.showNewOrder
      },
      showOrderOverview() {
        return this.$route.meta.showOrderOverview
      },

    }
  }
</script>

<template>
    <div>
        <div class="eda" :class="'mq-' + $mq">
            <div class="eda__notice">
                <!--    <global-notice
                            :blocking="true"
                            :show="telephoneMissing"
                            message="For å forbedre kommunikasjonen rundt bestillinger ber vi om at du legger inn telefonnummeret ditt."
                            action-target="/user"
                            action-label="Rediger profil"
                    />
                    -->
            </div>


            <!-- will render itself if necessary -->
            <v-modal-add-telephone/>


            <div class="eda__header">
                <a v-if="showBack" @click="$router.go(-1)" class="eda__header-link eda__back">

                    <div class="eda__back-icon">
                        <eda-icon icon="arrow-left" fill="white"></eda-icon>
                    </div>
                    <div class="eda__header-label">
                        {{ $t("layout.menu.back") }}
                    </div>
                </a>


                <router-link to="/cars" v-if="showNewOrder" class="eda__header-link eda__new">
                    <div class="eda__new-icon eda__header-icon">
                        +
                    </div>
                    <div class="eda__header-label">
                        {{ $t("layout.menu.newOrder") }}
                    </div>
                </router-link>

                <router-link to="/orders" v-if="showOrderOverview" class="eda__header-link eda__overview">
                    <div class="eda__list-icon eda__header-icon">
                        <eda-icon icon="list" fill="white"></eda-icon>
                    </div>
                    <div class="eda__overview-label eda__header-label">
                        {{ $t("layout.menu.orderList") }}
                    </div>
                </router-link>

                <div class="eda__retailer-logo" :class="{'eda__retailer-logo--minimized': minimizeLogo}">
                    <eda-link to="/">
                        <img class="eda__retailer-img" :src="logoUrl">
                    </eda-link>
                </div>

                <router-link to="/user" class="eda__header-link eda__user" v-if="showUser">
                    <div class="eda__user-icon eda__header-icon">
                        <eda-icon icon="user" fill="white"></eda-icon>
                    </div>
                    <div class="eda__username eda__header-label">
                        {{ getUser.firstName }}
                    </div>

                </router-link>
            </div>


            <div class="eda__content">
                <router-view></router-view>
            </div>

            <div class="eda__branding">
                <!--                <template v-if="showEdaLogo">
                                    <div class="eda__brand eda__eda">
                                        <eda-icon icon="eda" fill="#BFBFBF"></eda-icon>
                                    </div>
                                </template>
                                -->

                <div class="eda__brand eda__defa">
                    <eda-icon icon="defa" fill="#BFBFBF"></eda-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    @import '~@/scss/vendor/_reset.scss';
    @import '~@/scss/vendor/_polysizing.scss';
    @import '~@/scss/base/_typography.scss';
    @import '~@/scss/base/_defaults.scss';

    * {
        box-sizing: border-box
    }

    body {
        margin: 0;
    }

    .eda-notice {
        padding: 0em 0em 2em;
        color: white;
        font-style: oblique;
        font-size: 1.2em;
        text-align: center;
        width: 100%;
        color: lightgoldenrodyellow;

    }

    .eda {
        overflow: hidden;
        position: relative;
        width: 100%;
        min-height: 100vh;
        background-color: #0D1A0F;
        font-size: 1em;
        padding-bottom: 0em;
        font-family: "Poppins", sans-serif;

        &__notice {
            z-index: 10;
            position: relative;
        }
    }

    .eda::before {
        z-index: 0;
        content: '';
        width: 220vw;
        height: 150vh;
        position: absolute;
        left: -25vw;
        top: -25vh;
        transform: rotate(-8deg);
        border-radius: 100% 10% 100% 40%;
        background: linear-gradient(to bottom, #1d2720, #0d1a0f);

    }

    .eda__user {
        margin-left: auto;
    }

    .eda__header-icon {
        margin-right: 0.75em;
        width: 1.75em;
        fill: white;
        margin-top: .25em;
    }

    .eda__new-icon {
        width: 1em;
        margin-right: .5em;
        text-align: center;
    }

    .mq-tablet .eda__header-icon,
    .mq-mobile .eda__header-icon {
        margin-right: 0;
    }

    .mq-tablet .eda__header-label,
    .mq-mobile .eda__header-label {
        display: none;
    }

    .eda__header-link {
        color: white;
        text-decoration: none;
        padding: 0 1.5em;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .mq-tablet .eda__header-link,
    .mq-mobile .eda__header-link {
        padding: .5em .85em;
    }

    .eda__back {

        display: flex;
        align-items: center;
        cursor: pointer;
        color: white;
        text-decoration: none;
    }

    .eda__back-icon {
        margin-right: 0.75em;
        width: 1.75em;
        fill: white;
    }

    .eda__content {
        z-index: 2;
        position: relative;
        width: 100%;
        margin: 0 auto;
        max-width: 90em;
    }

    .eda__retailer-logo {
        position: absolute;
        top: calc(13vh);
        left: 50%;
        width: 11em;
        transform: translate(-50%, -50%);
        flex-grow: 1;

        transition: all .6s cubic-bezier(.075, .82, .165, 1)
    }

    .mq-mobile .eda__retailer-logo {
        width: 8em;
    }

    .eda__retailer-logo--minimized {
        top: 4.15em;
        width: 8.5em;

    }

    .mq-mobile .eda__retailer-logo--minimized {
        width: 4.5em;
        top: 2.7em;
    }

    .eda__branding {
        z-index: 1;
        position: relative;
        padding-top: 7em;
        padding-bottom: 2em;
        display: flex;
        justify-content: center;
    }

    .eda__brand {
        width: 4.5em;
        margin: 1em;
        fill: #BFBFBF;
    }

    .mq-mobile .eda__brand {
        width: 3em;
    }

    .eda__eda {
        width: 5.5em;
    }

    .mq-mobile .eda__eda {
        width: 3.7em;
    }

    .eda__retailer-img {
        width: 100%;
    }

    .eda__new {
        background-color: #00B27C;
        color: white;
        padding: 0.75em 2em;
        border-radius: 3em;
        text-decoration: none;
    }

    .eda__header {
        height: 7em;
        display: flex;
        width: 100%;
        align-items: center;
        padding: 2em 4em;
        justify-content: flex-start;
        color: white;
        position: relative;
        z-index: 2;
    }

    .mq-tablet .eda__header {

        padding: 0 1em;
    }

    .mq-mobile .eda__header {
        padding: 0 1em;
        height: 5.5em;

    }

    .eda-link {
        color: #00B27C
    }


</style>